/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function ComponentPropertiesIcon(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'ComponentPropertiesIcon',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"opacity":".4","fillRule":"evenodd","clipRule":"evenodd","d":"M8.479 1.692a1 1 0 0 0-.958 0l-5 2.727A1 1 0 0 0 2 5.297v5.406a1 1 0 0 0 .521.878l5 2.727a1 1 0 0 0 .958 0l5-2.727a1 1 0 0 0 .521-.878V5.297a1 1 0 0 0-.521-.878zM3.544 5 8 2.57 12.456 5 8 7.43zM3 5.842v4.861l4.5 2.455V8.297zm5.5 7.316 4.5-2.455v-4.86L8.5 8.296v4.86z","fill":"currentColor"}),createElement('path', {"fillRule":"evenodd","clipRule":"evenodd","d":"M13.74 11.439A.5.5 0 0 0 14 11V5a.5.5 0 0 0-.74-.439l-5.5 3a.5.5 0 0 0-.26.44v6a.5.5 0 0 0 .74.438z","fill":"currentColor"}))
}
